import Component from '../abstracts/Component';
import vex from "vex-js";

export default class NewPrivacyComponent extends Component {

  static get SELECTORS() {
    return {
      Form: ".js-validate-form",
    };
  }

  onB2Csignin() {
    $('body').on('change.bpr', 'input[name="param10"]', function (e) {
      $('.js-password-box').toggleClass('hidden');
    });
  }

  onNewsletterSignUp() {
    $('#newsletterForm').find('input[id="privacy"]').on('change.nlp', function (e) {
      const target = e.currentTarget;
      let id = target.id;
      let basicNewsletterSubmit = document.querySelector('button[data-target="' + id + '"]');
      let isDisabled = basicNewsletterSubmit.getAttribute('disabled');
      if (isDisabled) {
        $(basicNewsletterSubmit).attr("disabled", false);
      } else {
        $(basicNewsletterSubmit).attr("disabled", true);
      }
    });
  }

  onNewsletterLandingSignUp() {
    $('#newsletterLandingForm').find('input[id="privacy"]').on('change.nlp', function (e) {
      const target = e.currentTarget;
      let id = target.id;
      let basicNewsletterSubmit = document.querySelector('button[data-target="' + id + '"]');
      let isDisabled = basicNewsletterSubmit.getAttribute('disabled');
      if (isDisabled) {
        $(basicNewsletterSubmit).attr("disabled", false);
      } else {
        $(basicNewsletterSubmit).attr("disabled", true);
      }
    });
  }


  basicPrivacyAcceptance() {
    if(! $('input[id="basicPrivacy"], input[id="basicPrivacy-ft"], input[id="privacyNl_2"]').prop('checked')){
      $('#registerForm').find('button[type="submit"]').attr("disabled", true);
    }
    $('body').on('change.bpr', 'input[id="basicPrivacy"], input[id="basicPrivacy-ft"], input[id="privacyNl_2"]', function (e) {
      e.stopImmediatePropagation();
      let $container = $(e.currentTarget).closest('form').find('.js-privacy-opts');
      let $form = $(e.currentTarget).closest('form');
      //
      if ($(e.currentTarget).is(':checked')) {
        $container.removeClass('is-disabled');
        $container.find('input[type="radio"]').attr("disabled", false);
        if ( $('[name=newsletterProfiling]').is(':checked') && $('[name=newsletter]').is(':checked')) {
          $form.find('button[type="submit"],button[type="button"]').attr("disabled", false);
          $form.find('a.submit').attr("disabled", false).removeClass('disabled');
        }
        if ( $('[name="recalledBrandPrivacyData.profiled"]').is(':checked') && $('[name="recalledBrandPrivacyData.newsletter"]').is(':checked')) {
          $form.find('button[type="submit"]').attr("disabled", false);
        }
        if ($form.hasClass('js-contact-form')) {
          $form.find('button[type="submit"]').attr("disabled", false);
        }
        if ($("#newsletterForm input[name=privacy]").is(':checked')) {
          $form.find('button[type="submit"]').attr("disabled", false);
        }
      } else {
        $container.addClass('is-disabled');
        $container.find('input[type="radio"]').attr("disabled", true);
        $container.find('#newsletterProfiling1').prop("checked", false);
        $container.find('#newsletter1').prop("checked", false);
        $form.find('button[type="submit"]').attr("disabled", true);
        // enable submit btn
        let submitBtn = $('#basicPrivacy').closest('.container-privacy').find('#buttons a');
        submitBtn.attr("disabled", true);
        submitBtn.addClass('disabled');
      }
    });

    $('body').on('change.radioPrivacy', '[name="newsletterProfiling"], [name="newsletter"]', function (e) {
      e.stopImmediatePropagation();
      const $container = $(e.currentTarget).closest('form').find('.js-privacy-opts');
      let $form = $(e.currentTarget).closest('form');

      if ( $('[name=newsletterProfiling]').is(':checked') && $('[name=newsletter]').is(':checked')) {
        $form.find('button[type="submit"]').attr("disabled", false);
        //login privacy gdpr
        $form = $('#basicPrivacy').closest('.container-privacy').find('#buttons a');
        $form.attr("disabled", false);
        $form.removeClass('disabled');
      }
    });

    $('body').on('change.radioPrivacyRecall', '[name="recalledBrandPrivacyData.profiled"], [name="recalledBrandPrivacyData.newsletter"]', function (e) {
      e.stopImmediatePropagation();
      const $container = $(e.currentTarget).closest('form').find('.js-privacy-opts');
      const $form = $(e.currentTarget).closest('form');

      if ( $('[name="recalledBrandPrivacyData.profiled"]').is(':checked') && $('[name="recalledBrandPrivacyData.newsletter"]').is(':checked')) {
        $form.find('button[type="submit"]').attr("disabled", false);
      }
    });


    $('body').on('click', '.updatePrivacyButton', function (e) {

      const $container = $(e.currentTarget).closest('form');
      const currentNewsletterProfiling = $container.find(".current-profiling input:checked").attr('value');
      const currentNewsletter = $container.find(".current-newsletter input:checked").attr('value');
      const newsletterProfiling = $container.find(".profiling input:checked").attr('value');
      const newsletter = $container.find(".no-profiling input:checked").attr('value');
      const privacy = $container.find("#basicPrivacy").is(':checked');

      var $this = $(this);
      var href = $(".submit").data('href');

      $this.attr('disabled', true);

      $.ajax({
        url: href,
        type: 'POST',
        data: {
          'new-form-privacy': true,
          currentNewsletterProfiling: currentNewsletterProfiling,
          currentNewsletter: currentNewsletter,
          newsletterProfiling: newsletterProfiling,
          newsletter: newsletter,
          privacy: privacy
        },
        dataType: "html"
      }).done(function (resp) {
        $('.vex-close').trigger('click');
        $('.success-alert, .alert-success').removeClass("hidden");
        let isMobile = window.matchMedia('(max-width:767px)').matches;
        if (isMobile){
          $("html, body").animate({ scrollTop: 0 }, "slow");
        }
      }).fail(function (xhr) {
        console.log(xhr);
      });
    });

    $('body').on('click', '.wrapper-login-privacy .icon-close', function (e) {
      e.stopPropagation();
      $(this).closest('.alert-success').addClass('hidden');
    });

  }

  // recall privacy function
  // similar to older websites
  recallPrivacyConfirm(){
    let ctx = this;
    $('body').on('click','.js-apply-recall-options',function(e){
      let ctx = this;
      e.preventDefault();
      e.stopImmediatePropagation();
      let content = $('#privacy-usubscribe-modal').html();

      ctx.$emit(this.$customEvents.MODAL_EVENTS.show, {
        unsafeContent: content
      })

    })
  }

  getPage(url, showLoader = true) {

    const ajaxConf = {
      type: 'GET',
      url: url,
    };

    if (showLoader) ajaxConf.beforeSend = () => this.$emit(this.$customEvents.LOADER_EVENTS.show);

    return $.ajax(ajaxConf);
  }

  showPrivacyModal(){
    this.showPrivacyModal = $('body').data('showPrivacyModal');

    if (this.showPrivacyModal) {

      this.getPage('/action/ajax/modalprivacy')
        .then(res => {
        this.$emit(this.$customEvents.MODAL_EVENTS.show, {
          unsafeContent: res,
          modalClass: 'modal-privacy-recall vex-medium-width',
        });
    })
    .then( () => {
        $('.js-single-item').slick({
        draggable: false,
        arrows: false,
      });
      $('a[data-slide]').click(function(e) {
        e.preventDefault();
        let currentSlide = $(this).data('slide');
        $('.js-single-item').slick('slickGoTo', currentSlide - 1);
      });

      $('.js-wrapper-privacy-recall').on('change.privacyRecallModal', function (e) {
        e.stopImmediatePropagation();
        const $container = $(e.currentTarget).closest('.js-privacyRecallModal').find('.js-privacy-opts');
        const $form = $(e.currentTarget).closest('.js-privacyRecallModal');

        if ($(e.currentTarget).is(':checked')) {
          $container.removeClass('is-disabled');
          $container.find('input[type="radio"]').attr("disabled", false);
          if ( $('[name=newsletterProfiling]').is(':checked') && $('[name=newsletter]').is(':checked')) {
            $form.find('.js-apply-recall-options-modal').attr("disabled", false);
          }
        } else {
          $container.addClass('is-disabled');
          $container.find('input[type="radio"]').attr("disabled", true);
          $container.find('#newsletterProfiling1').prop("checked", false);
          $container.find('#newsletter1').prop("checked", false);
          $form.find('.js-apply-recall-options-modal').attr("disabled", true);
        }
      });

      $('[name="newsletterProfiling"], [name="newsletter"]').on('change.radioPrivacyRecallModal', function (e) {
        e.stopImmediatePropagation();
        const $container = $(e.currentTarget).closest('.js-privacyRecallModal').find('.js-privacy-opts');
        const $form = $(e.currentTarget).closest('.js-privacyRecallModal');

        if ( $('[name="newsletterProfiling"]').is(':checked') && $('[name="newsletter"]').is(':checked')) {
          $form.find('.js-apply-recall-options-modal').attr("disabled", false);
        }
      });
      this.recallPrivacyStep2();

    });
    }
  }

  recallPrivacyStep2(){
    $('body').on('click.recallPrivacyStep2', '.js-apply-recall-options-modal' ,function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      let newsletterProfiling = $('#newsletterProfiling1').prop('checked') ? true:false;
      let newsletter = $('#newsletter1').prop('checked') ? true:false;

      ///update privacy
      let currentNewsletterProfiling = $('[name="currentNewsletterProfiling"]').attr('value');
      let currentNewsletter = $('[name="currentNewsletter"]').attr('value');
      let href = $(this).data('href');

      $.ajax({
        url: href,
        type : 'POST',
        data : {
          'new-form-privacy': true,
          currentNewsletterProfiling: currentNewsletterProfiling,
          currentNewsletter : currentNewsletter,
          newsletterProfiling : newsletterProfiling,
          newsletter : newsletter,
          privacy : true
        },
        dataType : "html"
      }).done(function(resp) {

        $('.vex-close').trigger('click');
        if(resp == '{}'){
          $('.js-recall-privacy-message').removeClass("hidden");
        } else {
          $('.js-recall-privacy-message-error').removeClass("hidden");
        }

      }).fail(function(xhr) {
        console.log(xhr);
      });
    })

  }


  render() {
    super.render();
    this.onNewsletterSignUp();
    this.onNewsletterLandingSignUp();
    this.basicPrivacyAcceptance();
    this.onB2Csignin();
    this.showPrivacyModal();
    // this.recallPrivacyConfirm();
  }
}
